import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ClientService } from '../../core/services/client.service';
import { Client } from '../../core/models/client.model';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { NgIf } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ClientFormBaseComponent } from '../client-form-base.component';

@Component({
  selector: 'app-client-update',
  templateUrl: './client-update.component.html',
  styleUrls: ['./client-update.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, NgIf],
})
export class ClientUpdateComponent extends ClientFormBaseComponent implements OnInit {
  clientId: number | null = null;

  constructor(
    protected override fb: FormBuilder,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.clientId = this.route.snapshot.params['id'];
    if (this.clientId) {
      this.loadClientData(this.clientId);
    }
  }

  loadClientData(id: number): void {
    this.clientService.getClientById(id).subscribe({
      next: (client: Client) => {
        this.clientForm.patchValue(client);
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los datos del cliente:', error.message);
        this.errorMessage =
          error.error.message || 'Ocurrió un error al cargar los datos del cliente';
      },
    });
  }

  onSubmit(): void {
    if (this.clientForm.valid && this.clientId) {
      const updatedClient: Client = this.clientForm.value;

      this.clientService.updateClient(this.clientId, updatedClient).subscribe({
        next: response => {
          console.log('Cliente actualizado:', response);
          this.router.navigate(['/clients']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al actualizar el cliente:', error.message);
          this.errorMessage = error.error || 'Ocurrió un error al actualizar el cliente';
        },
        complete: () => {
          console.log('Solicitud de actualización de cliente completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
      this.errorMessage = 'Por favor, complete todos los campos obligatorios.';
    }
  }
}
